<template lang="pug">
section.wam-content.onboarding-georadar
    GeoradarPanel
    GeoradarMap
</template>

<script>
import GeoradarPanel from '@/components/onBoarding/GeoradarPanel'
import GeoradarMap from '@/components/onBoarding/GeoradarMap'

export default {
    name: 'Georadar',
    components: { GeoradarPanel, GeoradarMap }
}
</script>
